<template>
  <div class="basic-setting-content pl16 pr16">
    <el-form-item label="形象照" prop="waiter.images">
      <div class="draggable-list">
        <draggable class="wrapper" v-model="newImg">
          <transition-group>
            <div class="item" v-for="(item, index) in newImg" :key="item">
              <img v-img-url="item" />
              <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index)">
                <i class="el-icon-close"></i>
              </a>
            </div>
          </transition-group>
        </draggable>
        <div class="item img-select" @click="openProductUpload('image', 'image')">
          <i class="el-icon-plus"></i>
        </div>
      </div>
    </el-form-item>
    <Upload v-if="isProductUpload" :config="config" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload>
  </div>
</template>
<script>
import Upload from "@/components/file/Upload";
import draggable from "vuedraggable";
export default {
  components: {
    Upload,
    draggable
  },

  data() {
    return {
      isProductUpload: false,
      config: {},
      file_name: "image",
      newImg:[]
    };
  },
  inject: ["form"],
  mounted() {
    if(this.form.waiter.images){
      this.newImg = JSON.parse(this.form.waiter.images);
    }
  },
  computed: {
   
  },
  methods: {
    /*打开上传图片*/
    openProductUpload: function(fileType, file_name) {
      console.log("=========fileType, file_name====", fileType, file_name);
      this.file_name = file_name;
      if (fileType == "image") {
        this.config = {
          total: 9,
          fileType: "image"
        };
      } else {
        this.config = {
          total: 1,
          fileType: "video"
        };
      }
      this.isProductUpload = true;
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if (e != null) {
        if (this.file_name == "video") {
          this.form.waiter.video_id = e[0].fileId;
          this.form.waiter.video = e[0];
        } else if (this.file_name == "image") {
          let newarr = e.map(item => item.filePath);
          if (this.newImg) {
            this.newImg = this.newImg.concat(newarr);
          } else {
            this.newImg = [];
            this.newImg = this.newImg.concat(newarr);
          }
          this.$set(this.form.waiter, "images", this.newImg);
        }
      }
      this.isProductUpload = false;
    },
    /*删除商品图片*/
    deleteImg(index) {
      this.newImg.splice(index, 1);
    }
  }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/technician/technicianlist/part/waiterphoto.vue